module.exports = __webpack_public_path__ + "img/Apache-Mesos.95124b1.svg";